import { some } from 'lodash';

/**
 * Returns `true` if the entity contains a truthy value
 * for any of the passed in keys
 *
 * NOTE: One downside of using this approach to "filter invalid entities"
 * is that if new fields are added to the form, we need to update
 * the list of `validKeys`.  Otherwise we may filter out an entity unintentionally
 */
export function entityContainsValidKeys<T extends object>(
    entity: T,
    validKeys: Extract<keyof T, string>[]
) {
    return some(
        Object.entries(entity),
        ([objectKey, objectValue]: [Extract<keyof T, string>, unknown]) => {
            return validKeys.includes(objectKey) && !!objectValue;
        }
    );
}
